export const summerConstants = {
    SET_SUMMER_CHOICE: "SET_SUMMER_CHOICE",
    SET_SUMMER_PAUSE_DATES: "SET_SUMMER_PAUSE_DATES",
    SET_SUMMER_STAGE_BOOKING: "SET_SUMMER_STAGE_BOOKING",
    RESET_SUMMER_CHOICE: "RESET_SUMMER_CHOICE",
    MARK_SUMMER_COCKPIT_VIEWED: "MARK_SUMMER_COCKPIT_VIEWED",
    SET_JUNE_PAUSE: "SET_JUNE_PAUSE",
    SET_RESUME_PREFERENCE: "SET_RESUME_PREFERENCE",
    SET_SUMMER_MONTH_CHOICE: "SET_SUMMER_MONTH_CHOICE",
    SET_SUMMER_MONTH_COURSES_CONFIG: "SET_SUMMER_MONTH_COURSES_CONFIG",
    SET_SUMMER_RESUME_DATE: "SET_SUMMER_RESUME_DATE",
    SET_SUMMER_RESUME_OFFER: "SET_SUMMER_RESUME_OFFER",
    SET_SUMMER_RESUME_CONFIG: "SET_SUMMER_RESUME_CONFIG",
    CONFIRM_SUMMER_CHOICES: "CONFIRM_SUMMER_CHOICES",
}
